import {
  DateRangeParams,
  useDateRangeParams,
} from "@/common/hooks/use-date-range-params";
import { invariant } from "@/common/utils/invariant";

import {
  getAvailableFilters,
  getFilterByDateRange,
  getFilterParams,
} from "./quick-filters.utils";

const useCurrentDateRange = () => {
  const dateFilters = getAvailableFilters();
  const searchParams = useDateRangeParams();
  const currentDateFilter = getFilterByDateRange(
    dateFilters,
    getFilterParams(searchParams as DateRangeParams),
  );
  invariant(currentDateFilter?.dateFrom);
  invariant(currentDateFilter.dateTo);

  return {
    dateFrom: currentDateFilter.dateFrom,
    dateTo: currentDateFilter.dateTo,
  };
};

export { useCurrentDateRange };
